import { inject, Injectable, Injector } from '@angular/core';
import { AuthToken } from '@libs/shared/models';
import { Observable, of, take } from 'rxjs';
import { UserAuthHandler } from '../../auth.model';
import { AuthTokenState } from '../../state';

@Injectable({
  providedIn: 'root',
})
export class StorageUserAuthHandler extends UserAuthHandler {
  private readonly injector: Injector = inject(Injector);

  public login(): Observable<AuthToken | undefined> {
    return this.injector.get(AuthTokenState).readToken().pipe(
      take(1),
    );
  }

  public override refresh(): Observable<AuthToken | undefined> {
    return of(undefined);
  }

  public override logout(): Observable<void> {
    return of(undefined);
  }
}
